import axios from 'axios'
import Vuex from 'vuex'
import store from '@/store'

var _ = require('lodash')

const apiUrl = process.env.VUE_APP_API_URL
const apiKey = process.env.VUE_APP_API_KEY

var h = {}

if (!_.isNil(apiKey)) {
  h = {
    "Content-Type": "application/json",
    "x-api-key": `${apiKey}`
  }
} else {
  h = {
    "Content-Type": "application/json"
  }
}

const apiCall = axios.create({
  baseURL: apiUrl,
  headers: h
})

export default apiCall

//Handle JWT Token
apiCall.interceptors.request.use(config => {
  var tokenJWT = localStorage.getItem('token')
  if (tokenJWT) {
    config.headers['Authorization'] = 'Bearer ' + tokenJWT;
  }
  return config
});

//Token Refresh
apiCall.interceptors.response.use(function(response) {
  return response;
}, function(error) {
  if (401 === error.response.status) {
    apiCall.post('/v1/auth/refreshToken', {
      refresh_token: localStorage.getItem('refresh-token')
    })
    .then(function(response){
      if(response.headers["x-token-refresh"]){
        localStorage.setItem('token', response.headers["x-token-id"])
        localStorage.setItem('refresh-token', response.headers["x-token-refresh"])
        location.reload();
      }
    })
  } else {
    return Promise.reject(error);
  }
});